import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.LOAD_QUIZ_TAKE](state, { questions, take }) {

    Vue.set(state, 'showSuccessBanner', !take.quiz_passed && state.isStudyGuide)
    questions = questions || []
    Vue.set(state, 'questions', questions)
    Vue.set(state, 'take', take)
    if (questions.length > 0)
      Vue.set(state, 'currentQuestionId', questions[0].id)
    Vue.set(state, 'currentAnswerId', null)
    Vue.set(state, 'currentQuestionResult', null)
  },

  [types.ANSWER_SELECTED](state, answerId) {
    Vue.set(state, 'currentAnswerId', answerId)
  },

  [types.SUBMIT_ANSWER](state, { questionId, result, take }) {
    // Increment triesCounter
    Vue.set(state.triesCounter, questionId, (state.triesCounter[questionId] || 0) + 1)

    Vue.set(state, 'take', take)
    Vue.set(state, 'currentQuestionResult', result)

    const question = state.questions.find(q => q.id == questionId)

    // To display the results
    const answer = question.answers.find(a => a.id == state.currentAnswerId)
    Vue.set(answer, 'correct', result.correct)

    // Do not show the question if it's already answered anymore
    if (result.correct)
      Vue.set(question, 'skip', true)

  },

  [types.NEXT_QUESTION](state) {
    const index = state.questions.findIndex(q => q.id == state.currentQuestionId)
    setCurrentQuestion(state, nextQuestionId(state.questions, index))
  },

  [types.GO_TO_THE_QUESTION](state, shift) {
    const index = state.questions.findIndex(q => q.id == state.currentQuestionId)
    const new_index = index + shift
    if (new_index >= 0 && new_index <= state.questions.length - 1) {
      setCurrentQuestion(state, state.questions[new_index].id)
    }
  },

  [types.TRIGGER_STUDY_GUIDE_PLAYER](state, payload) {
    Vue.set(state.study_guide_player, 'hidden', payload)
  },

  [types.CLOSE_SUCCESS_BANNER](state) {
    if (state.take.quiz_passed && state.showSuccessBanner)
      Vue.set(state, 'showSuccessBanner', false)
  }
}

function nextQuestionId(questions, index) {
  const questionsLength = questions.length
  index++

  // It should never happens. Avoid infinite loop.
  if (questions.every(q => q.skip)) return;

  while (true) { // eslint-disable-line no-constant-condition
    if (index >= questionsLength) index = 0

    let question = questions[index]
    if (!question.skip) return question.id
    index++
  }
}

function setCurrentQuestion(state, question) {
  Vue.set(state, 'currentQuestionId', question)
  Vue.set(state, 'currentAnswerId', null)
  Vue.set(state, 'currentQuestionResult', null)
}
